import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../common/AutoBindComponent";
import IndienenForm from "./IndienenForm";
import IndienenPageHelper from "./IndienenPageHelper";
import { uploadOneFile, deleteOneFile } from "../common/DownloadUploadFilesHelper";

import * as types from "../../constants/ComponentConstants";
import * as DomainConstants from "../../constants/DomainConstants";
import * as indienenActions from "../../actions/indienenActions";
import * as layoutActions from "../../actions/layoutActions";
import * as documentActions from "../../actions/documentActions";


class IndienenPage extends AutoBindComponent {

    constructor(props, context) {
        super(props, context);

        this.state = {
            pdf: {},
            documenten: [],
            fileSessionStarted: false,
            timer: null,
            pollCount: 0
        };

        this.pageHelper = new IndienenPageHelper(this);
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    componentWillUnmount() {
        this.pageHelper.unmount();
    }

    componentWillReceiveProps(nextProps) {
        this.pageHelper.update(nextProps);
    }

	handleOnDienIn(event) {
        this.pageHelper.onDienIn(event);
    }

    handleOnGeneratePdf() {
        this.pageHelper.onGeneratePdf();
    }

    handleOnDropFiles(component, files) {
        if (files.length > 0) {
            this.pageHelper.handleFileRequest(component, files[0], (comp, file) => {
                uploadOneFile(this, this.props.uploadDocument, this.props.indienen.dossierId, DomainConstants.DocumentTab.Indienen, comp, file);
            });
        }
    }

    handleOnDeleteFile(component, fileName) {
        this.pageHelper.handleFileRequest(component, fileName, (comp, file) => {
            deleteOneFile(this, this.props.deleteDocument, this.props.indienen.dossierId, DomainConstants.DocumentTab.Indienen, comp, file);
        });
    }

    getFilesForDossierComponent(componentName) {
        if (!this.state.documenten || this.state.documenten.length === 0) {
            return [];
        }
        const folder = this.state.documenten.find(x => x.name === componentName);
        return folder && folder.files ? folder.files : [];
    }

    isReadyToRender() {
        // entity not loaded? not ready yet...
        if (!this.props.indienen || !this.props.indienen.dossierId) {
            return false;
        }

        return true;
    }

    render() {
        if (!this.isReadyToRender()) {
            return null;
        }

        const fileTypes = {
            extensions: ".pdf",
            mimeTypes: "application/pdf"
        };

        const ondertekendePdfFiles = this.getFilesForDossierComponent(DomainConstants.ComponentName.OndertekendePDF);
        const heeftOndertekendePdf = ondertekendePdfFiles && ondertekendePdfFiles.length > 0;

        return (<IndienenForm
            indienen={this.props.indienen}
			onDienIn={this.handleOnDienIn}
            disabled={this.disabled}
            color={types.COLOR_GREEN}
            pdf={this.state.pdf}
            isPollingDocument={!!this.state.timer}
            generatePdf={this.handleOnGeneratePdf}
            ondertekendePdfFiles={ondertekendePdfFiles}
            onDropOndertekendePdf={(files) => this.handleOnDropFiles(DomainConstants.ComponentName.OndertekendePDF, files)}
            onDeleteOndertekendePdf={(fileName) => this.handleOnDeleteFile(DomainConstants.ComponentName.OndertekendePDF, fileName)}
            fileTypes={fileTypes}
            fileSessionStarted={this.state.fileSessionStarted}
            disableOndertekendePdfUpload={heeftOndertekendePdf}
        />);
    }
}

function mapStateToProps(state, ownProps) {
    const infrastructuurId = state.infrastructuren[0] !== undefined ? state.infrastructuren[0].id : null;

    return {
        indienen: state.indienen,
        disabled: state.settings.lockAllDossiers,
        infrastructuurId: infrastructuurId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        confirmIndienen: bindActionCreators(indienenActions.confirmIndienen, dispatch),
        loadIndienen: bindActionCreators(indienenActions.loadIndienen, dispatch),
        loadLayout: bindActionCreators(layoutActions.loadIndienenPageLayout, dispatch),
        getContent: bindActionCreators(documentActions.getContentWithoutLoading, dispatch),
        generatePdf: bindActionCreators(indienenActions.generatePdf, dispatch),
        uploadDocument: bindActionCreators(documentActions.uploadDocument, dispatch),
        deleteDocument: bindActionCreators(documentActions.deleteDocument, dispatch),
        startFileSession: bindActionCreators(documentActions.startFileSession, dispatch),
        endFileSession: bindActionCreators(documentActions.endFileSession, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(IndienenPage);
